import type { DelegationReason } from '@meitu/x-design-text';

const DELEGATED_EMOJI_FONT_FAMILIES = ['"Apple Color Emoji"', '"Segoe UI Emoji"', '"Noto Color Emoji"'] as const;

const DELEGATED_GENERIC_FONT_FAMILY = 'sans-serif';

export const formatFontFamilyName = (name: string) => name.replace(/\./g, '');

/**
 * 生成宿主测量与 SVG delegated glyph 共用的字体 fallback 链。
 *
 * @param fontFamily - 文字引擎为当前 delegated glyph 选择的主字体族。
 * @param reason - 当前 glyph 委托给宿主处理的原因。
 * @returns 可直接写入 Canvas 或 SVG font-family 的完整 fallback 链。
 */
export const resolveDelegatedFontFamily = (fontFamily: string, reason: DelegationReason): string => {
    /**
     * 在需要时为单个字体族补充 CSS 引号并转义内部双引号。
     *
     * @param family - 待写入 CSS font-family 的单个字体族。
     * @returns 可安全拼入 fallback 链的字体族。
     */
    const quote = (family: string): string =>
        /^[A-Za-z0-9_-]+$/.test(family) ? family : `"${family.replace(/"/g, '\\"')}"`;

    const families = fontFamily ? [quote(fontFamily)] : [];

    if (reason === 'emoji') families.push(...DELEGATED_EMOJI_FONT_FAMILIES);
    families.push(DELEGATED_GENERIC_FONT_FAMILY);

    return families.join(', ');
};
